<template>
  <layout-auth style="background-color: #f3f5f7 !important">
    <v-container class="py-8">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("users.confirmTitle") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h2 class="text-h5 font-weight-light">{{ $t("users.userData") }}</h2>
          <h3 class="text-subtitle-1 font-weight-medium">
            {{ $t("users.confirmSubtitle") }}
          </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="3">
          <label class="second-type-label">{{ $t("users.nameAlias") }}</label>
          <p class="text-subtitle-1">{{ model.alias }}</p>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="3">
          <label class="second-type-label">{{ $t("users.email") }}</label>
          <p class="text-subtitle-1">{{ model.email }}</p>
        </v-col>
      </v-row>
      <v-row class="pb-5">
        <v-col cols="12" sm="12" lg="12">
          <v-btn
            v-if="!confirmed"
            depressed
            @click="confirmCreate"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("users.confirm") }}
          </v-btn>
          <v-btn
            v-else
            depressed
            @click="finalizar"
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end m-2"
          >
            {{ $t("supplierData.finish") }}
          </v-btn>
          <v-btn
            v-if="!confirmed"
            outlined
            @click="$router.go(-1)"
            :color="entityConfig.primaryColor"
            class="float-end m-2 v-btn-width-default"
          >
            {{ $t("users.goBack") }}
          </v-btn>
          <v-btn
            v-else
            plain
            :color="entityConfig.primaryColor"
            class="float-end m-2"
            @click="print"
          >
            <v-icon left> mdi-printer-outline </v-icon>
            {{ $t("users.print") }}
          </v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
      <overlay :visible="spinner"></overlay>
    </v-container>
  </layout-auth>
</template>

<script>
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import Api from "../../Services/index";

export default {
  components: {
    "layout-auth": LayoutAuth,
    Overlay,
  },
  data() {
    return {
      confirmed: false,
      spinner: false,
      entityConfig: {},
      checkbox: false,
      model: { alias: "", email: "" },
      respuesta: "",
      respuestaData: "",
      message: "",
      messageData: "",
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    let newUser = JSON.parse(sessionStorage.getItem("userConfirm"));
    if (newUser) {
      this.model = newUser;
      Api.defaults.headers.common["Authorization"] =
        "Bearer " + sessionStorage.getItem("authtoken");
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    print() {
      window.print();
    },
    confirmCreate() {
      this.spinner = true;
      const formData = Object.assign({}, this.model);
      const userInfo = JSON.parse(sessionStorage.getItem("userData"));
      formData.codNrbeEn = userInfo.codNrbeEn;
      formData.languageCode = "ES";
      formData.principalUser = false;
      formData.supplierId = userInfo.supplierId;
      formData.password = `TempPa5sw0rd>${Math.floor(Math.random() * 10) + 1}`;

      Api.post("/usuarios", formData)
        .then((response) => {
          this.respuestaData = response.data.message;
          sessionStorage.removeItem("userConfirm");
          this.confirmed = true;
          if (this.respuestaData == "Created only email") {
            this.$toast.success(this.$t("users.createdMessageExistenteSinConfirmar"));
          } else {
            this.$toast.success(this.$t("users.createdMessage"));
          }
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    finalizar() {
      this.$router.push("/gestion-de-usuarios");
    },
  },
};
</script>
